import {
    GET_ALL_MEDICAL_RECORDS_SUCCESS,
    CREATE_MEDICAL_RECORD_SUCCESS,
    DELETE_MEDICAL_RECORD_SUCCESS,
    MEDICAL_RECORD_ERROR,
    UPDATE_MEDICAL_RECORD_SUCCESS
  } from '../actions/types';
  
  const initialState = {
    records: [],
    loading: true,
    error: {},
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      case GET_ALL_MEDICAL_RECORDS_SUCCESS:
        return { ...state, records: payload, loading: false };
      case CREATE_MEDICAL_RECORD_SUCCESS:
        return { ...state, records: [...state.records, payload], loading: false };
        case UPDATE_MEDICAL_RECORD_SUCCESS:
        return { ...state, records: [...state.records, payload], loading: false };
  
      case DELETE_MEDICAL_RECORD_SUCCESS:
        return {
          ...state,
          records: state.records.filter((rec) => rec.id !== payload),
          loading: false,
        };
      case MEDICAL_RECORD_ERROR:
        return { ...state, error: payload, loading: false };
      default:
        return state;
    }
  }